<template >

	<v-autocomplete 
		v-model="select"
		autocomplete	
		auto-select-first
		:dark="dark"
		:height="height"
		autofocus	
		ref="autocomplete"
		:label=label		
		:items="buildingItems"
		@change="returnSelection"
		clearable
		:prepend-icon="prepend"
		:flat="flat"
		light
		hide-no-data
		hide-details		
		:solo-inverted="soloinverted"
		:outline="outline"
		solo
		return-object
		:single-line="singleline"
		:filter="customFilter"
		v-on:change="changeHandler"
		style="overflow:hidden;"
	>
		<template
	        slot="selection"
	        slot-scope="{ item, tile }"
	      >
	      	<v-layout v-if="select" v-on:click="select = null">
	        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
	        	{{item.bldgAlpha}}
	        </v-list-tile-avatar>
	        <v-list-tile-content>
	          <v-list-tile-title>
	          	{{item.name}}
	          </v-list-tile-title>
	          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
	        </v-list-tile-content>
	    	</v-layout>
	      </template>
		<template
	        slot="item"
	        slot-scope="{ item, tile }"
	      >
	        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
	        	{{item.bldgAlpha}}
	        </v-list-tile-avatar>
	        <v-list-tile-content>
	          <v-list-tile-title>
	          	{{item.name}}
	          </v-list-tile-title>
	          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
	        </v-list-tile-content>
	      </template>
	</v-autocomplete>

</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
	data: () => ({
		loading: false,
		select: null,
	}),

	props: {
    	singleline: Boolean,
    	soloinverted: Boolean,
    	solo: Boolean,
    	dark: Boolean,
    	outline: Boolean,
    	flat: { type: Boolean, default: true },
    	prepend: String,
    	height: String,
    	label: {type: String, default: "Building Name / Number / Addr" },
    	changeHandler: Function, 
    },

    computed: {
		buildingItems : function () {
		  const items = []
		  this.$store.state.space.buildings.forEach(bldg => {
			bldg.text = `${bldg.bldgAlpha} - ${bldg.name}`
			bldg.value = bldg.bldgAlpha
			// Load only 'Active' status buildings
			if (bldg.status == 'A') { items.push(bldg) }
		  })
		  return items
		},
	},

	methods: {
		returnSelection: function (value) {
			this.$emit('return-selection', value)	
		},	

		customFilter (item, queryText, itemText) {
			//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
			
	        const bldgAlpha = item.bldgAlpha.toLowerCase()
	        const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
	        					item.commonName + item.shortName + item.aliasName

	        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
	        if (queryText.length > 3 ) {
	        	return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
	        } else {
	        	return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
	        }
	    },
	}
}

</script>

<style>
.v-list__tile--highlighted {
	height: 70px;
}

.smallerAvatar .v-avatar--tile {
	font-size: 10pt !important;
}

</style>




// WEBPACK FOOTER //
// src/components/forms/AutocompleteBuilding.vue